import { apiClient } from '@/lib/api-client'
import type { DashboardUser } from '../types/dashboard-user'

export const fetchDashboardUser = async (
  employeeId: string
): Promise<DashboardUser> => {
  const response = await apiClient.get<DashboardUser>(`/user/${employeeId}`)
  return response.data
}
